<section>
  <div #topSection class="top-section" [hidden]="editSectionOpen">
    <p class="mt-3 mb-2 user-select-none">To create a section press the "Add section" button. Choose tables from the list or select on the canvas.</p>
    <button class="btn btn-info w-100 user-select-none" [disabled]="disabled" (click)="addSection()">+ Add section</button>
  </div>

  <div *ngIf="editSectionOpen" class="edit-form" #editSection>
    <div class="background-canvas h-100">
      <form [formGroup]="form">
        <p class="floorplan-builder-label user-select-none">tables</p>
        <frontend-dropdown
          class="mb-2"
          bindValue="id"
          name="services"
          bindLabel="name"
          clearAllText="Clear"
          formControlName="tables"
          [items]="availableTables"
          [multiple]="true"
          [class.is-invalid]="tablesControl.touched && tablesControl.invalid"
          [clearable]="true"
        ></frontend-dropdown>
        <control-messages [control]="tablesControl"></control-messages>

        <p class="floorplan-builder-label user-select-none">section name</p>
        <input
          id="input-modal-name"
          type="text"
          formControlName="name"
          name="name"
          noWhitespace
          class="form-control mb-2"
          required
          trTrimSpaces
        />
        <control-messages [control]="nameControl"></control-messages>

        <p class="floorplan-builder-label user-select-none">section color</p>

        <div class="section-color mb-3" #sectionColorRef>
          <div
            [style.background]="selectedColor"
            [(colorPicker)]="selectedColor"
            (colorPickerChange)="selectionColorChange.emit($event)"
            [cpCmykEnabled]="false"
            [cpToggle]="true"
            [cpWidth]="sectionColorRef.offsetWidth + 'px'"
            cpAlphaChannel="always"
            [cpDialogDisplay]="'inline'"
            cpOutputFormat="hex"
            class="picker background-background"
          ></div>
        </div>
      </form>

      <div class="actions d-flex mt-2">
        <button *ngIf="editSectionId !== undefined" class="btn btn-danger w-100 mr-2 user-select-none" (click)="delete()">Delete</button>
        <button class="btn btn-info w-100 mr-1 user-select-none" [disabled]="!this.form.valid" (click)="save()">Save</button>
        <button
          class="btn ml-1 w-100 user-select-none"
          [ngClass]="editSectionId !== undefined ? 'btn-outline-danger' : 'btn-danger'"
          (click)="cancelEdit()"
        >Cancel</button>
      </div>
    </div>
  </div>

  <div *ngIf="!editSectionOpen" class="sections" [style.height]="(windowHeight - (contentHeight + topSection.offsetHeight + 16)) + 'px)'">
    <div *ngFor="let section of sections" class="section-item background-canvas">
      <p class="title user-select-none">{{ section.name }}</p>
      <p class="tables color-primary user-select-none">{{ sectionTableCountById[section.id] }}</p>

      <tr-icon class="edit" [icon]="icon.edit" (click)="edit(section)"></tr-icon>
    </div>
  </div>
</section>
